import React, { useState } from 'react';
import { isBoolean, reduce } from 'lodash';
import Text from '../../../../Components/Base/Text/Text';
import MagicForm from '../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import FullPageLoading from '../../../../Components/Utils/FullPageLoading/FullPageLoading';
import { HealthPlanCode } from '../../../../Enums/HealthPlanCode.enum';
import { useEffectAsync } from '../../../../helpers';
import apiClient from '../../../../Services/ApiClient';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import HealthPlanPrintPdfModal from '../HealthPlanPrintPdf/HealthPlanPrintPdfModal';
import HealthPlanVaccinationBabyScheme from './HealthPlanVaccinationBabyScheme';
import HealthPlanVaccinationDiabetesScheme from './HealthPlanVaccinationDiabetesScheme';
import { updateHealthPlanUserItem } from '../../Services/healthPlan.service';

interface HealthPlanVaccinationProps {
	onSuccess?: any;
	disableSubmit?: boolean;
}

interface VaccinationApiStructure {
	[key: string]: {
		toggle: boolean;
	};
}

interface FormStructure {
	[key: string]: boolean;
}

const parseFormToApi = (values: FormStructure): VaccinationApiStructure => {
	const parsedValues = reduce(
		values,
		(acc, value, key) => ({
			...acc,
			...(value && {
				[key]: isBoolean(value)
					? {
							toggle: value,
					  }
					: value,
			}),
		}),
		{},
	);

	return parsedValues;
};

export default function HealthPlanVaccination(
	props: HealthPlanVaccinationProps,
) {
	const { onSuccess, disableSubmit } = props;
	const { healthPlanUser, activeHealthPlanUserItem, healthPlan } =
		useHealthPlanContext();
	const [printModalOpen, setPrintModalOpen] = useState(false);
	const [isInitialized, setIsInitialized] = useState(false);
	const [defaultData, setDefaultData] = useState(null);

	useEffectAsync(async () => {
		setDefaultData(activeHealthPlanUserItem?.extra?.data ?? null);
		setIsInitialized(true);
	});

	let formScheme: ItemScheme[];

	switch (healthPlan?.code) {
		case HealthPlanCode.BABY:
			formScheme = HealthPlanVaccinationBabyScheme;
			break;
		case HealthPlanCode.DIABETES:
		default:
			formScheme = HealthPlanVaccinationDiabetesScheme;
			break;
	}

	const handleSave = async (values: any) => {
		if (healthPlanUser?.healthPlanId && activeHealthPlanUserItem?.id) {
			await updateHealthPlanUserItem({
				healthPlanId: healthPlanUser.healthPlanId,
				healthPlanUserId: healthPlanUser.id,
				healthPlanItemId: activeHealthPlanUserItem.id,
				data: {
					extra: {
						data: parseFormToApi(values),
					},
				},
			});
			setPrintModalOpen(true);
		}
	};

	const handleAfterPrint = async () => {
		setPrintModalOpen(false);
		onSuccess?.();
	};

	if (!isInitialized) {
		return <FullPageLoading />;
	}

	return (
		<>
			<Text
				className='danger-text mb-4'
				tx={'diabetes.healthPlanDefaultChange'}
			/>
			<MagicForm
				formScheme={formScheme}
				onSubmit={handleSave}
				defaultValues={defaultData}
				disableSubmit={disableSubmit}
			/>
			<HealthPlanPrintPdfModal
				opened={printModalOpen}
				onClose={handleAfterPrint}
				healthPlanUser={healthPlanUser}
				healthPlanUserItem={activeHealthPlanUserItem}
			/>
		</>
	);
}
